import type { IconProps } from '../types/IconProps.ts';
export const ChevronUp: IconProps = {
    name: 'ChevronUp',
    children: [
        `<path d="m6 15 5.65-5.65c.2-.2.5-.2.7 0L18 15" />`,
    ]
};